module.exports = __webpack_public_path__ + "static/media/ic-credit-card.4a72e689.svg";